import { css } from '@emotion/core'

export const tagStyles = css`
  width: 6em;
  min-width: 100px;
  max-width: 250px;
  @media (min-width: 768px) {
    width: 10em;
  }
`
